import { FC } from "react";
import { AppPartType } from "../../../types";

type Prop = {
  appPart: AppPartType;
};
const Label: FC<Prop> = () => {
  return <></>;
};

export default Label;
